export const env = { ...process.env, ...window['env'] };



// WEBPACK FOOTER //
// ./src/env.js